import { useState } from "react";
import "./Home.css";
import addcartitem from "./Cartactions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
const Productdetail = ({ id, img, num, price, title, desc, stock }) => {
    const Navigate = useNavigate();
    const dispatch =  useDispatch();
    const[quantity,setquantity] = useState(1)
    const increasequantity = ()=>{
        const count = document.querySelector(".count")
        if(stock !==0 && Number(count.value)>= stock){
            return
        }else{
            const qty = Number(count.value)+1;
            setquantity(qty);
        }
    }
    const decreasequantity = ()=>{
        const count = document.querySelector(".count")
        if(Number(count.value)===1){
            return
        }else{
            const qty = Number(count.value)-1;
            setquantity(qty);
        }
    }
    return (
        <div className="row f-flex justify-content-around">
            <div className="col-12 col-lg-5 img-fluid my-5" id="product_image">
                <img className="d-block w-100" src={img} alt={title} height="500" width="500" />


            </div>

            <div className="col-12 col-lg-5 my-lg-5">

                <h3>{title} </h3>


                <hr />
                <p className="parah"> <i>
                    {desc}
                </i></p>


                <hr />



                <h5 id="product_price"> <i>Rs.{price} </i> </h5>
                <div className="stockCounter d-inline">
                    <span className="btn btn-danger minus" onClick={decreasequantity} >-</span>

                    <input type="number" className="form-control count d-inline mx-2" value={quantity} />

                    <span className="btn btn-primary plus" onClick={increasequantity} >+</span>
                </div>

                
                <div className="accordion my-4" id="accordionExample">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <i className="fa-regular fa-clock"></i> <span className="ms-4"> Delivery duration </span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <ul>
                                    <li>Preparation - 3 to 7 working days</li>
                                    <li>Within Tamilnadu Delivery - 1 or 2 working days after preparation</li>
                                    <li> Outside Tamilnadu Delivery - 2 to 4 working days after preparation (delivery time varies from shipping pincodes and deliver partners)</li>
                                </ul>
                                <p>
                                    Preparation starts only after sharing order id, images and required details over email and email id to be shared along with order id to us over 9962585299 (WhatsApp)
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <i className="fa-regular fa-square-check"></i> <span className="ms-4"> Customization details </span>
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <p>To ensure your customization preferences are met, kindly send the images and details to hello@leegifts.in

                                    Please mention your order ID in the subject line. Additionally, if your order includes multiple products requiring customization, kindly send a separate email for each product.</p>
                            </div>
                        </div>
                    </div>

                </div>
               




                <p id="product_seller mb-3 " className="font">Sold by: <strong>Leegifts</strong></p>
                <button type="button" id="cart_btn"

                    className="btn btn-primary mt-2 " onClick={()=>{
                        dispatch(addcartitem(num,quantity))
                        Navigate("/cart")

                    }}
                >Add to Cart</button>




            </div>

        </div>


    )


}
export default Productdetail;






